<template>
  <div :class="`checkbox-label-list-item ${selected ? 'selected' : ''}`" tabindex="0">
    <check-box :selected="checkbox.selected" />
    <span class="star-rating">
      <span
        v-for="n in 5"
        :key="n"
        class="star"
        :class="n <= filledStars ? 'filled' : 'empty'"
      >★</span>
    </span>
    <span class="star-label">{{ itemData.label }}</span>
  </div>
</template>

<script>
import CheckBox from "@/components/lists/item-types/CheckBox";

export default {
  name: "StarRatingListItem",
  components: { CheckBox },
  props: {
    itemData: {
      type: Object
    }
  },
  computed: {
    selected() {
      return !!this.itemData?.checkbox?.selected;
    },
    checkbox() {
      return this.itemData?.checkbox;
    },
    filledStars() {
      return this.itemData?.value ?? 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-label-list-item {
  display: flex;
  align-items: center;
  font-size: 11px;
  cursor: pointer;

  > * {
    margin-right: 0.5em;
  }

  &.selected {
    color: var(--list-item-select-color);
  }
}

.star-rating {
  display: inline-flex;
  line-height: 1;
}

.star {
  font-size: 18px;
  &.filled {
    color: #f0a500;
  }
  &.empty {
    color: #d5d5d5;
  }
}

.star-label {
  font-size: 12px;
  color: inherit;
}
</style>
